<!--
* @Name：采购订单申请物料页面
* @Author: 王超
* @Date: 2022-03-09
-->
<template>
  <div>
    <hi-card v-for="(item, index) in detailsList" :key="item.purchaseApplyItemId" :row-index="index + 1">
      <van-row>
        <span>需求类型：</span>
        <span>{{ item.demandTypeDict | dictFilter(productType) }}</span>
      </van-row>
      <van-row>
        <span>物料描述：</span>
        <span>{{ item.maktx }}</span>
      </van-row>
      <van-row>
        <span>单价：</span>
        <span>{{ item.price }}</span>
      </van-row>
      <van-row>
        <span>外购销售单价：</span>
        <span>{{ item.suggestedPrice }}</span>
      </van-row>
      <van-row>
        <span>供应商：</span>
        <span>{{ item.suppName }}</span>
      </van-row>
      <van-row>
        <span>价格来源：</span>
        <span>{{ item.priceSourceDict | dictFilter(priceSourceOptions) }}</span>
      </van-row>
      <van-row>
        <span>最低价：</span>
        <span>{{ item.lowestPrice }}</span>
      </van-row>
      <van-row>
        <span>是否含税：</span>
        <span>{{ item.isTax | dictFilter(yesNoOptions) }}</span>
      </van-row>
      <van-row>
        <span>币种：</span>
        <span>{{ item.currencyDict | dictFilter(currencyDictOptions) }}</span>
      </van-row>
      <van-row>
        <span>税率：</span>
        <span>{{ item.taxRate | dictFilter(taxRateDictOptions) }}</span>
      </van-row>
      <van-row>
        <span>采购数量：</span>
        <span>{{ item.purchaseQty }}</span>
      </van-row>
      <van-row>
        <span>到货日期：</span>
        <span>{{ item.deliveryDate }}</span>
      </van-row>
      <van-row>
        <span>申请人：</span>
        <span>{{ item.applyUserName }}</span>
      </van-row>
      <van-row>
        <span>申请部门：</span>
        <span>{{ item.applyDept }}</span>
      </van-row>
    </hi-card>
  </div>
</template>

<script>
import { selectDetail, selectLowestPrice } from '@/api/purchaseRequest'
export default {
  name: 'MaterialDetails',
  data() {
    return {
      // prCreateHeadId: this.$store.getters.businessKey,
      prCreateHeadId: this.$route.query.businessKey,
      detailsList: []
    }
  },
  props: {
    // 币种编码
    currencyDict: {
      type: String
    }
  },
  computed: {
    // 价格来源
    priceSourceOptions() {
      return this.$store.getters.dicts.price_source
    },
    // 币种
    currencyDictOptions() {
      return this.$store.getters.dicts.currency_dict
    },
    // 税率
    taxRateDictOptions() {
      return this.$store.getters.dicts.tax_rate
    },
    // 是否含税
    yesNoOptions() {
      return this.$store.getters.dicts.yes_no
    },
    // 需求类型
    productType() {
      return this.$store.getters.dicts.po_type
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    // 获取物料明细列表
    async initData() {
      const response = await selectDetail(this.prCreateHeadId)
      this.detailsList = response.data
      // 查询历史最低单价
      const res = await selectLowestPrice(this.detailsList)
      for (let i = 0; i < res.data.length; i++) {
        if (res.data[i].lowestPrice !== undefined && res.data[i].lowestPrice !== 0) {
          if (res.data[i].price !== res.data[i].lowestPrice) {
            res.data[i].diaLowPrice = 'Y'
          } else {
            res.data[i].diaLowPrice = 'N'
          }
        } else {
          res.data[i].diaLowPrice = 'N'
        }
      }
      this.detailsList = res.data
    }
  }
}
</script>
